import { render } from "./VideoButton.vue?vue&type=template&id=19ab4ebb&scoped=true"
import script from "./VideoButton.vue?vue&type=script&lang=js"
export * from "./VideoButton.vue?vue&type=script&lang=js"

import "./VideoButton.vue?vue&type=style&index=0&id=19ab4ebb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19ab4ebb"]])

export default __exports__